import { render } from "./Description.vue?vue&type=template&id=8a6a7f64&scoped=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"

import "./Description.vue?vue&type=style&index=0&id=8a6a7f64&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-8a6a7f64"

export default script